import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import LinearGradient from 'react-native-linear-gradient';

type THexButtonProps = {
  label: React.ReactNode;
  onPress: () => void;
  showHexagon?: boolean; // Optional prop to control hexagon visibility
  width?: number;
  height?: number;
  backgroundColor?: string;
  borderColor1?: string;
  borderColor2?: string;
  gradientBorderHeight?: number;
  hexagonContent?: React.ReactNode;
  hexagonFillColor?: string;
  hexagonStrokeColor?: string;
  justifyLabelFlex?: 'flex-start' | 'center' | 'flex-end'; // Added prop for label alignment
  marginRight?: number;
  disabled?: boolean;
};

export default function HexagonButton(props: THexButtonProps) {
  const {
    label,
    onPress,
    showHexagon = false,
    width = 57.37,
    height = 48.75,
    backgroundColor = '#FEDD88',
    borderColor2 = '#FFCF53',
    borderColor1 = '#FF9900',
    gradientBorderHeight = 55,
    hexagonContent = null,
    hexagonFillColor = '#FFB800',
    hexagonStrokeColor = '#E6A700',
    justifyLabelFlex = 'center',
    marginRight = 0,
    disabled,
  } = props;

  return (
    <LinearGradient
      colors={[borderColor1, borderColor2]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[styles.gradientBorder, { height: gradientBorderHeight, marginRight }]}
    >
      <TouchableOpacity
        style={[
          styles.container,
          { width, height, backgroundColor },
          disabled && { opacity: 0.5, backgroundColor: '#FEDD88' }, // dim button
        ]}
        onPress={!disabled ? onPress : undefined} // prevent press if disabled
        activeOpacity={0.8}
        disabled={disabled} // optional: ensures RN ignores touches
      >
        {/* Left Label */}
        <View style={[styles.labelContainer, { justifyContent: justifyLabelFlex }]}>
          <Text style={styles.label}>{label}</Text>
        </View>

        {showHexagon && (
          <View style={styles.hexContainer}>
            <Svg width="65.7" height="57" viewBox="0 0 100 100" style={styles.hexagon}>
              {/* Hexagon Shape */}
              <Path
                d="M25 5 L75 5 L95 50 L75 95 L25 95 L5 50 Z"
                fill={hexagonFillColor}
                stroke={hexagonStrokeColor}
                strokeWidth="1"
              />
            </Svg>
            <View style={styles.hexagonContentContainer}>{hexagonContent}</View>
          </View>
        )}
      </TouchableOpacity>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    position: 'relative',
  },
  labelContainer: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    height: '100%',
  },
  label: {
    fontFamily: 'Secular One',
    fontSize: 16,
    fontWeight: '400',
    color: '#121212',
  },
  hexContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: 10,
  },
  gradientBorder: {
    borderRadius: 16,
    padding: -4,
  },
  hexagon: {
    position: 'absolute',
  },
  hexagonContentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
